import { Action as HistoryAction } from "history"

import { atom, deepMap } from "nanostores"

export interface ScrollPosition {
  left: number
  top: number
}

export interface ScrollPositionStore {
  [x: string]: ScrollPosition | undefined
}

const $scrollPositionStore = deepMap<ScrollPositionStore>({})
const $lastHistoryAction = atom<HistoryAction | undefined>(undefined)

export function saveScrollPosition(
  pathname: string,
  scrollPosition: ScrollPosition
) {
  $scrollPositionStore.setKey(pathname, scrollPosition)
}

export function getScrollPosition(pathname: string) {
  return $scrollPositionStore.get()[pathname] || { left: 0, top: 0 }
}

export function saveLastHistoryAction(action: HistoryAction) {
  $lastHistoryAction.set(action)
}

export function getLastHistoryAction() {
  return $lastHistoryAction.value
}
